import { DEFAULT_LANGUAGE, detectBrowserLanguage, getLanguage, normalizeLanguage, setLanguage, SUPPORTED_LANGUAGES } from './languageService';
import en from './locales/en';
import ko from './locales/ko';

const dictionaries = {
  en,
  ko,
};

function getPathValue(source, keyPath) {
  return String(keyPath || '').split('.').reduce((current, key) => (
    current && Object.prototype.hasOwnProperty.call(current, key) ? current[key] : undefined
  ), source);
}

export function t(key, language = getLanguage(), replacements = {}) {
  const normalizedLanguage = normalizeLanguage(language);
  const value = getPathValue(dictionaries[normalizedLanguage], key);
  const resolved = value !== undefined && value !== null
    ? value
    : getPathValue(dictionaries[DEFAULT_LANGUAGE], key);
  const text = resolved !== undefined && resolved !== null ? String(resolved) : key;
  return Object.entries(replacements).reduce((current, [name, replacement]) => (
    current.replace(new RegExp(`\\{${name}\\}`, 'g'), String(replacement))
  ), text);
}

export {
  DEFAULT_LANGUAGE,
  detectBrowserLanguage,
  getLanguage,
  normalizeLanguage,
  setLanguage,
  SUPPORTED_LANGUAGES,
};
